var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 10.5H8.75C7.7835 10.5 7 11.2835 7 12.25V43.75C7 44.7165 7.7835 45.5 8.75 45.5H47.25C48.2165 45.5 49 44.7165 49 43.75V12.25C49 11.2835 48.2165 10.5 47.25 10.5Z",
    stroke: "#9BA1A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 36.7498L18.0031 25.7467C18.166 25.5813 18.3601 25.45 18.5741 25.3604C18.7882 25.2708 19.0179 25.2246 19.25 25.2246C19.4821 25.2246 19.7118 25.2708 19.9259 25.3604C20.1399 25.45 20.334 25.5813 20.4969 25.7467L30.2531 35.5029C30.416 35.6683 30.6101 35.7996 30.8241 35.8892C31.0382 35.9788 31.2679 36.025 31.5 36.025C31.7321 36.025 31.9618 35.9788 32.1759 35.8892C32.3899 35.7996 32.584 35.6683 32.7469 35.5029L37.2531 30.9967C37.416 30.8313 37.6101 30.7 37.8241 30.6104C38.0382 30.5208 38.2679 30.4746 38.5 30.4746C38.7321 30.4746 38.9618 30.5208 39.1759 30.6104C39.3899 30.7 39.584 30.8313 39.7469 30.9967L49 40.2498",
    stroke: "#9BA1A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 24.5C35.5747 24.5 36.75 23.3247 36.75 21.875C36.75 20.4253 35.5747 19.25 34.125 19.25C32.6753 19.25 31.5 20.4253 31.5 21.875C31.5 23.3247 32.6753 24.5 34.125 24.5Z",
    fill: "#9BA1A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.d6f3d2a61e445ce7667ecfb5fa7e0489.svg";
export { ForwardRef as ReactComponent };